
import Log from '../log';
let log = Log.getLogger('MultiSceneForApp.utils.loadTextFromUrl');

export default function loadTextFromUrl(url, callback) {
    let options = {
        method: 'GET',
        mode: 'cors'
    };

    fetch(new Request(url, options))
        .then(response => {
            return response.text();
        })
        .then(content => {
            callback(null, content);
        })
        .catch(error => {
            log.error('fetch text failed:', error);
            callback(error);
        });
}
